import axios from 'axios';

// project imports
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { STORAGE_AUTH_TOKEN } from 'constants/store';
import { loginRequest, pca } from 'libs/pca';
import { getTokenFromStorage } from 'utils/auth';

export const BASE_URL = process.env.REACT_APP_BASE_URL;

const api = axios.create({
    baseURL: BASE_URL,
    headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use(
    async (config) => {
        if (!config.headers) return config;

        const token = getTokenFromStorage();
        const account = pca.getActiveAccount();

        if (!account && token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }

        if (account) {
            try {
                const tokenResponse = await pca.acquireTokenSilent({ ...loginRequest, account });
                config.headers['Authorization'] = `Bearer ${tokenResponse.accessToken}`;
                localStorage.setItem(STORAGE_AUTH_TOKEN, JSON.stringify(tokenResponse.accessToken));
            } catch (error) {
                if (error instanceof InteractionRequiredAuthError) {
                    // Need to interactively get token (popup or redirect)
                    // No token is returned immediately here — the redirect will reload your app
                    pca.acquireTokenRedirect({ ...loginRequest, account });
                } else {
                    console.error('MSAL token error:', error);
                }
            }
        }

        return config;
    },
    (error) => Promise.reject(error)
);

function logout() {
    localStorage.clear();
    if (window.location.pathname !== '/login') {
        window.location.href = '/login';
    }
}

api.interceptors.response.use(
    (response) => response,
    (error) => {
        const account = pca.getActiveAccount();
        if (error.response.status === 401 && account) {
            try {
                pca.acquireTokenRedirect({ ...loginRequest, account });
            } catch (msalError) {
                console.error('MSAL token refresh failed', msalError);
                logout();
            }
        } else if (error.response.status === 401) {
            logout();
        }

        return Promise.reject(error);
    }
);

export default api;
